<template lang="pug">
	.easy-creative--fast-change.flex-col.space-large.swing-in-top-fwd(v-if="info.fastChange.enabled", v-show="info.fastChange.visible", :class="{ 'disabled': isBusy }")
		.flex-row.space.align-center
			fas(icon="sliders")
			b.upper {{$tCaption('Fast change')}}	
		.flex-col.space-large
			Question(v-for="(question, idx) in questions", :question="question", :info="info", :questionTypes="questionTypes", :key="question.Oid",
				:error="question.IsRequired && !question.__value ? $tCaption('Please answer this question') : null", v-if="!question.__hidden", :class="{ 'disabled-controls': question.__disabled }")
		.flex-row.space.justify
			.flex-row.space
			.flex-row.space
				DxButton(type="normal", :text="$tCaption('Apply changes')", icon="fas fa-check", @click="applyChanges")
</template>

<script>
	import { questionTypes } from './helper';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import Question from './EasyCreativeQuestion.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-fast-change',
		props: ['info'],
		components: {
			DxButton, Loader, Question
		},
		data() {
			return {
				questionTypes,
				isApplyingChanges: false
			};
		},
		computed: {
			questions() {
				return (this.info.fastChange.questions || []).filter(f => f.__isVisible);
			},
			isBusy() {
				return this.isApplyingChanges || !this.info.states.audioGenerated;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeFastChange = this;
			
		},
		methods: {
			async applyChanges() {
				this.isApplyingChanges = true;
				
				try {
					this.$emit('fast-change--apply-changes');

					let script = this.info.scriptBuilder();
					let generator = this.info.audioGenerator();
					
					if (script) {
						await script.loadAiScript(void 0, void 0, void 0, void 0, { preventNavigation: true });

						if (__DEBUG__)
							console.debug('Apply changes: script loaded');
					}

					if (generator) {
						generator.generate(true);
					}
				} finally {
					this.isApplyingChanges = false;
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--fast-change {
		margin-bottom: 20px;
		padding: 10px;
		border: 2px solid var(--branding-input-bg);
		border-radius: 4px;

		&.swing-in-top-fwd {
			animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
		}

		&.disabled {
			pointer-events: none;
			opacity: 0.5 !important;
		}

		@keyframes swing-in-top-fwd {
			0% {
				transform: rotateX(-100deg);
				transform-origin: top;
				opacity: 0;
			}
			100% {
				transform: rotateX(0deg);
				transform-origin: top;
				opacity: 1;
			}
		}
	}

	.fast-change-button {
		font-weight: 100;
		user-select: none;
		transition: 0.2s;
		
		&.active {
			color: var(--branding-highlight-color) !important;
		}
	}
</style>
